export default __webpack_public_path__ + "static/media/dog-old-age.038c5df4.svg";